/* angular:styles/component:css;1313be556d1d314becf4210a688be9cbd3f0540658f26f9a49efb0eff32ef4ee;/app/src/app/shared/animations/search-box-v3.component.ts */
.additional-charges-form {
  background-color: #ffffff;
  width: 95%;
  height: 45px;
  padding-inline-start: 8px;
  padding-top: 3px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 24px;
  padding-left: 15px;
  margin-bottom: 0;
  border-radius: 16px;
  display: flex;
  align-items: center;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-standard {
  padding-left: 0px;
  position: inherit;
  z-index: 10;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  min-width: 82px;
  border-radius: 16px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #dfdfdf;
  background-color: #ffffff;
}
.container-fixed {
  padding-left: 0px;
  padding-right: 8px;
  position: fixed;
  z-index: 1010;
  max-height: 100%;
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #dfdfdf;
  background-color: #ffffff;
}
.header {
  padding-left: 16px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #8f8e95;
}
.items-container {
  padding-left: 8px;
  padding-right: 8px;
}
.item {
  width: 100%;
  height: 33px;
  border-radius: 20px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
}
.item:hover {
  background-color: #eaeaea;
}
.item-text {
  position: absolute;
  left: 8px;
  top: 8px;
  vertical-align: sub;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  cursor: pointer;
}
.item-text-bold {
  position: absolute;
  left: 8px;
  top: 8px;
  vertical-align: sub;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: normal;
  color: #a6a6a6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  cursor: pointer;
}
.select-all-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 84px;
}
.clickable {
  background: none;
  border: none;
  padding: 0;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  color: #4f356e;
  text-decoration: underline;
}
.not-clickable {
  background: none;
  border: none;
  padding: 0;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  color: #a6a6a6;
  text-decoration: underline;
}
.spacer {
  padding-bottom: 8px;
}
.top-bottom-padding {
  margin-bottom: 5px;
  padding-top: 6px;
  padding-bottom: 16px;
  height: fit-content;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
}
.form-div {
  position: relavtive;
  width: 95%;
  padding-left: 12px;
}
.form-img {
  position: absolute;
  left: 20px;
  top: 14px;
}
.code-changeable-img {
  position: absolute;
  right: 8px;
  top: 15px;
  transform: rotate(-180deg);
}
.form-text {
  border: 0px;
  width: 100%;
  height: 38px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-inline-start: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.no-result-text {
  color: #a6a6a6;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  font-family: "Poppins-Regular";
}
input:focus {
  outline: none;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #c8c7cc;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 3px;
  padding: 16px 13px;
}
.selected-select-all {
}
/*# sourceMappingURL=search-box-v3.component.css.map */
